<template>
  <div class="t-calendar" :class="{'t-calendar_small': mobileCalendar}">
    <button v-if="type.value.value !== 1 && mobileState" 
        class="t-btn t-btn_white t-btn_full t-calendar__btn" 
        @click="SetType({value: 1, label: 'Месяц'})">
        <span> 
          <svg class="t-calendar__btn-svg" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.6001 4.00078H12.4001M1.6001 4.00078L5.2001 1.30078M1.6001 4.00078L5.2001 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Календарь 
        </span>
    </button>

    <div class="t-calendar-body" :class="{'t-calendar-body_snall': mobileState}">

      <cmp-calendar-header></cmp-calendar-header>
      <cmp-month-grid v-if="type.value.value === 1"
                      :lessons="lessons" :lesson_type="lesson_type"></cmp-month-grid>
      <template v-else>
                <!-- выводить недельную сету на десктопе -->
              <cmp-weekly-grid v-if="!mobileState" :lesson_index="lesson_index"></cmp-weekly-grid>
                <!-- выводить сету по дням на десктопе -->
              <cmp-day-grid v-else :lesson_index="lesson_index"></cmp-day-grid>
      </template>

      <cmp-time-create 
            v-if="type.value.value !== 1 && ($route.name === 'courses_create' || $route.name === 'courses_edit')"
            :lessons="lessons" :lesson_type="lesson_type"
            :type="mobileState?'day':'week'"></cmp-time-create>
      <cmp-time 
            v-if="type.value.value !== 1 && $route.name === 'courses_info'"
            :type="mobileState?'day':'week'"></cmp-time>
      <cmp-time-my-courses 
            v-if="type.value.value !== 1 && $route.name === 'my_courses'"
            :type="mobileState?'day':'week'"></cmp-time-my-courses>
      <cmp-time-my-entries 
            v-if="type.value.value !== 1 && $route.name === 'my_entries'"
            :type="mobileState?'day':'week'"></cmp-time-my-entries>

      <cmp-calendar-forms v-if="$route.name === 'courses_create' || $route.name === 'courses_edit'" :lessons="lessons" :course="course" :lesson_type="lesson_type" :lesson_index="lesson_index"></cmp-calendar-forms>
    </div>
  </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    import CalendarHeader from './CalendarHeader.vue'

    import ModalForm from './Create/ModalForm.vue'
    import TimeCreate from './Create/Time.vue'
    import Time from './View/Time.vue'
    import TimeMyCourses from './MyCourses/Time.vue'
    import TimeMyEntries from './MyEntries/Time.vue'

    import MonthGrid from './MonthGrid.vue'
    import WeeklyGrid from './WeeklyGrid.vue'
    import DayGrid from './DayGrid.vue'

    export default {
        props: ['lesson_type', 'lessons', 'lesson_index', 'course'],
        components: {
            'cmp-calendar-header': CalendarHeader,
            'cmp-calendar-forms': ModalForm,
            'cmp-month-grid': MonthGrid,
            'cmp-day-grid': DayGrid,
            'cmp-weekly-grid': WeeklyGrid,
            'cmp-time-create': TimeCreate,
            'cmp-time': Time,
            'cmp-time-my-courses': TimeMyCourses,
            'cmp-time-my-entries': TimeMyEntries
        },
        computed: {
            ...mapGetters('calendar', ['type']),
            ...mapGetters(['mobileState', 'mobileCalendar'])
        },
        methods: {
          ...mapActions('calendar', ['SetType']),
        },
    }
</script>

<style lang="sass">
.t-calendar
  display: flex
  flex-direction: column
  position: relative
  &__arrow
    display: flex
    margin-right: 16px
    button
      cursor: pointer
      width: 40px
      height: 40px
      background: transparent
      border: none
      outline: none
      border-radius: 50%
      display: flex
      align-items: center
      justify-content: center
  &_small
    // width: calc(100% - 32px)
    max-width: 320px
    width: 100%
    margin: 0 auto
    .t-day__container
      justify-content: center
    .t-month-grid
      justify-content: space-between
  &__btn
    margin-bottom: 24px
    span
      position: relative
    &-svg
      position: absolute
      right: calc(100% + 12px)
      bottom: 33%
  &__forms
    z-index: 15

.t-calendar-body
  display: flex
  flex-direction: column
  position: relative
  &_snall
    padding: 8px
    background: #FFFFFF
    box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
    border-radius: 16px

.t-day
  padding: 8px
  width: calc(100% / 7)
  flex: none
  height: 80px
  position: relative
  &._confirmed
    &:before
      background: #9866f5
      border: 1px solid #9866f5
    p
      color: #fff
  &:before
    content: ''
    position: absolute
    z-index: 1
    top: 1px
    right: 1px
    bottom: 1px
    left: 1px
    border: 1px solid $disabled
    border-radius: 4px
    transition: all .2s
  > *
    display: block
    position: relative
    z-index: 2
  &__container
    margin: 0 0 8px
    display: flex
    justify-content: space-between
  &__current
    font-size: 14px
    color: $grey
    line-height: 1.2
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  &__date
    font-size: 14px
    line-height: 1.2
    position: relative
    z-index: 3
  &__name
    color: $blue
    line-height: 1.2
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  &__time
    font-size: 14px
    line-height: 1.2
    color: $grey
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  &__buttons
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    display: flex
    align-items: center
    justify-content: center
    opacity: 0
    transition: opacity .2s
    button
      cursor: pointer
      margin: 0 4px
      width: 40px
      height: 40px
      box-shadow: $shadow
      background: $blue_gradient
      border-radius: 1000px
      display: flex
      align-items: center
      justify-content: center
      border: none
      outline: none
      svg 
        margin: auto
      @media (max-width: 1200px)
        width: 36px
        height: 36px
        margin: 0
  &_hover
    cursor: pointer
  &_active
    cursor: pointer
    &:before
      border-color: $blue
  &_disabled
    pointer-events: none
    cursor: default
    &:before
      border-color: $grey_light
    .t-day__name
      color: $grey
  &_select
    cursor: pointer
    &:before
      background: $blue_gradient
    .t-day__name, .t-day__time, .t-day__date
      color: #ffffff
  &_small
    // width: 36px
    width: calc((100%/ 7) - 4px)
    height: 36px
    text-align: center
    line-height: 36px
    margin: 2px
    padding: 0
    &:before
      top: -2px
      bottom: -2px
      left: unset
      right: 50%
      transform: translate(50%, 0)
      width: 36px
      max-width: 100%
      height: 36px
      border-radius: 50%
      border-color: transparent
    .t-day__date
      margin: 0
      line-height: 36px
    &.t-day_active, &.t-day_hover
      &:before
        border: 1px solid $blue
        cursor: pointer
      color: $blue
    &.t-day_select
      &:before
        background: linear-gradient(90deg, #52A8F2 0%, #6BD9F2 100%)
        box-shadow: 0 8px 24px rgba(0, 145, 207, 0.2)
      color: #ffffff
    &.t-day_disabled
      color: rgba(132, 193, 246, 0.4)
      pointer-events: none
      border: none
  &._today
    &:before
      border-color: $warning
  @media (min-width: 770px)
    &:not(.t-day_disabled):not(.t-day_select):not(.t-day_notActive):hover
      &:before
        border-color: $blue
      .t-day__buttons
        opacity: 1

.t-calendar-lessons
  position: absolute
  // top: 96px
  bottom: 0
  left: 0
  right: 1px
  display: grid
  grid-column-gap: 2px
  grid-row-gap: 2px
  grid-template-columns: 88px repeat(7, calc((100% - 102px)/7))
  grid-template-rows: repeat(48, 38px)
  &._day
    top: 60px
    grid-template-columns: 70px calc((100% - 80px))

.t-calendar-lesson
  border-radius: 4px
  border: 2px solid $blue
  position: relative
  z-index: 11
  padding: 5px
  background: #ffffff
  cursor: pointer
  &__time
    margin-bottom: 8px
    font-size: 14px
    line-height: 1.2
    display: block
  &__title
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    font-size: 14px
    line-height: 1.2
    color: $blue
    width: 100%
    display: block
    max-height: 100%
  &__del
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    margin: auto
    cursor: pointer
    width: 35px
    height: 35px
    box-shadow: $shadow
    background: $blue_gradient
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    border: none
    outline: none
    transition: all .2s
    opacity: 0
  &_disabled
    cursor: default
    border-color: $grey_light
    .t-calendar-lesson__title, .t-calendar-lesson__time
      color: $grey
  &_select
    background: $blue_gradient
    .t-calendar-lesson__title, .t-calendar-lesson__time
      color: #ffffff
      white-space: normal
  &_hover
    cursor: pointer
  &._small
    .t-calendar-lesson__time, t-calendar-lesson__title
      margin-bottom: 0
      line-height: 1
      font-size: 12px
  @media (min-width: 769px)
    &:hover
      .t-calendar-lesson__del
        opacity: 1
</style>


// WEBPACK FOOTER //
// src/vue_components/Calendar/Calendar.vue